import {
  Box,
  Button,
  Checkbox,
  CheckboxGroup,
  Divider,
  Flex,
  FormControl,
  FormLabel,
  Grid,
  Icon,
  Image,
  Input,
  Select,
  SimpleGrid,
  Text,
  Textarea,
} from "@chakra-ui/core";
import React, { useState } from "react";
import CardFooter from "../CardFooter";
import LinkedIn from "../../../../../static/assets/icons/LI-In-Bug.png";
import Facebook from "../../../../../static/assets/icons/facebook.png";

const LanguageInput = ({ index, lang, del, eachLang, setLang }) => (
  <Grid
    marginY="2em"
    templateColumns="repeat(auto-fit, minmax(120px, 1fr))"
    gap="1em"
  >
    <Input type="text" placeholder="English" />
    <Select
      placeholder="Select Fluency"
      onChange={(e) => {
        eachLang.fluency = e.target.value;
        lang[index] = eachLang;
        // setLang([...lang, eachLang])
        // setLang({ ...eachLang, fluency: e.target.value })
      }}
      value={eachLang.fluency}
    >
      <option value="fluent">Fluent</option>
      <option value="">Professional Fluency</option>
      <option value="">Native (Mother Tongue)</option>
      <option value="">Intermediate Fluency</option>
    </Select>
    <Checkbox defaultIsChecked={eachLang.read}>Read</Checkbox>
    <Checkbox defaultIsChecked={eachLang.write}>Write</Checkbox>
    <Checkbox defaultIsChecked={eachLang.speak}>Speak</Checkbox>
    <Button variant="link" onClick={() => del(index)} width="20px">
      <Icon name="delete" />
    </Button>
  </Grid>
);

function OtherDetails() {
  const demoLang = {
    language: "English",
    fluency: "fluent",
    read: false,
    write: true,
    speak: false,
  };
  const [lang, setLang] = useState([demoLang]);

  const addLang = () => {
    setLang([...lang, demoLang]);
  };
  const removeLang = (index) => {
    if (index !== 0) {
      setLang(lang.splice(index, 1));
    }
  };

  return (
    <Box p="10">
      <Text fontSize="2xl">Language</Text>
      <Divider />
      <SimpleGrid marginY="2em" minChildWidth="120px" spacing="1em">
        <FormControl>
          <FormLabel>Language</FormLabel>
          {lang.map((each, i) => (
            <LanguageInput
              lang={lang}
              del={removeLang}
              index={i}
              key={each.language}
              setLang={setLang}
              eachLang={each}
            />
          ))}
          <Button
            onClick={addLang}
            boxShadow="lg"
            padding="0"
            borderRadius="50%"
          >
            <Icon name="add" />
          </Button>
          {/* <Stack isInline>
                        <Input placeholder="English" />
                        <Select placeholder="Fluent" />
                        <RadioGroup isInline>
                            <Radio>Read</Radio>
                            <Radio>Write</Radio>
                            <Radio>Speak</Radio>
                        </RadioGroup>
                    </Stack>
                    <Stack isInline>
                        <Input placeholder="English" />
                        <Select placeholder="Fluent" />
                        <RadioGroup isInline>
                            <Radio>Read</Radio>
                            <Radio>Write</Radio>
                            <Radio>Speak</Radio>
                        </RadioGroup>
                    </Stack> */}
        </FormControl>
      </SimpleGrid>
      <Text mt="20" fontSize="2xl">
        Desired Job
      </Text>
      <Divider />
      <SimpleGrid marginY="2em" minChildWidth="120px" spacing="1em">
        <FormControl my="5">
          <FormLabel>Job Type</FormLabel>
          <SimpleGrid minChildWidth="80px" spacing="1em">
            <Checkbox>Permanent</Checkbox>
            <Checkbox>Temporary</Checkbox>
          </SimpleGrid>
        </FormControl>
        <FormControl my="5">
          <FormLabel>Employment Type</FormLabel>
          <SimpleGrid minChildWidth="80px" spacing="1em">
            <Checkbox>Full Time</Checkbox>
            <Checkbox>Part Time</Checkbox>
          </SimpleGrid>
        </FormControl>
      </SimpleGrid>
      <Text mt="20" fontSize="2xl">
        Affirmative Action
      </Text>
      <Divider />
      <SimpleGrid marginY="2em" minChildWidth="120px" spacing="1em">
        <FormControl>
          <FormLabel>Category</FormLabel>
          <Input placeholder="General" />
        </FormControl>
        <FormControl>
          <FormLabel>Physically Challenged</FormLabel>
          <CheckboxGroup isInline>
            <Checkbox>Yes</Checkbox>
            <Checkbox>No</Checkbox>
          </CheckboxGroup>
        </FormControl>
        <FormControl>
          <FormLabel>Description</FormLabel>
          <Textarea placeholder="type something ..." />
        </FormControl>
      </SimpleGrid>
      <Text fontSize="2xl">Website URL</Text>
      <Divider />
      <Box p="5">
        <Text fontWeight="bold">Category</Text>
        <Flex direction="column">
          <Flex my="5">
            <Image mr="5" src={Facebook} size="40px" />
            <Input placeholder="Facebook Profile Link" />
          </Flex>
          <Flex my="5">
            <Image mr="5" src={LinkedIn} size="40px" />
            <Input placeholder="LinkedIn Profile Link" />
          </Flex>
          <Button
            alignSelf="center"
            justifySelf="left"
            rounded="full"
            padding="0"
            boxShadow="lg"
          >
            <Icon name="add" />
          </Button>
        </Flex>
      </Box>
      <CardFooter />
    </Box>
  );
}

export default OtherDetails;
